// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#sub option {width: 500px;}\n#firms option {width: 300px;}\n\n#schet-form input,\n#schet-form select {\n    width: 100%\n}\n\n.btn.btn-primary {\n    font-weight: bold;\n}\n.btn.btn-big {\n    height: 30px;\n}\n\nselect-firm > div {\n    min-width: 250px;\n}", ""]);
// Exports
module.exports = exports;
